export type ShipmentBlankType = 'client' | 'production'

export const SHIPMENT_BLANK_TYPE_PATH: Record<ShipmentBlankType, string> = {
    client: 'blank-jpeg',
    production: 'production-blank-jpeg',
}

export const BLANK_TYPE_LABELS: Record<ShipmentBlankType, string> = {
    client: 'клиентский бланк',
    production: 'производственный бланк',
}

/** Цвет кнопок превью/скачивания бланка */
export const BLANK_TYPE_BUTTON_COLOR: Record<ShipmentBlankType, 'cyan' | 'magenta'> = {
    client: 'cyan',
    production: 'magenta',
}